var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerPC"},[_c('div',{staticClass:"footerPC_body"},[_c('div',{staticClass:"footer_email"},[_c('span',{staticClass:"footer_email_font"},[_vm._v("Copyright © airdrop.ylem.network")])])])])
}]

export { render, staticRenderFns }